import {connect} from 'react-redux'
import {
    ActionsRow,
    commons,
    FixedDropDownButton,
    Icon,
    Loader,
    modal,
    utils
} from "@mc/mc-legacy";
import {Button, ButtonToolbar, CardBody, Col, DropdownItem, Row} from "reactstrap";
import AdminPage from "./AdminPage";
import * as ciselnikActions from "../../actions/ciselnikActions";
import CiselnikApi from "../../api/gen/cgo/CiselnikApi";
const {sinkEvent} = commons;
import SouborAtributForm from "../../forms/SouborAtributForm";
import TablePanel from "../../components/TablePanel";
import ZmenitPoradiModal from "../../components/ZmenitPoradiModal";
import {toastr} from "react-redux-toastr";
import './SouborAtributyPage.scss';
import CustomCheckbox from "../../components/CustomCheckbox";
import {Component} from "react";
import * as React from "react";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Stránka administrace - Atributy souborů
 */
class SouborAtributyPage extends Component<WithTranslation> {

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate() {
        this.fetchData();
    }

    fetchData = () => {
        this.props.dispatch(ciselnikActions.fetchSouborAtributyIfNeeded());
    };

    handleCreateSouborAtribut = () => {
        const {souborAtributyList, t} = this.props;
        this.props.dispatch(modal.ModalActions.show(
            SouborAtributForm,
            {
                onSubmit: (data) => {
                    return CiselnikApi.createSouborAtribut(data);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(ciselnikActions.invalidateSouborAtributy());
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                initialValues: {poradi: souborAtributyList.rows.length + 1}
            },
            t('admin.new_file_attribute'),
            {size: "lg", className: "soubor-atribut-form-modal"}
        ));
    };

    handleEditSouborAtribut = (souborAtribut) => {
        const {t} = this.props;
        this.props.dispatch(modal.ModalActions.show(
            SouborAtributForm,
            {
                onSubmit: (data) => {
                    return CiselnikApi.updateSouborAtribut(data, data.id);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(ciselnikActions.invalidateSouborAtributy());
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                initialValues: souborAtribut
            },
            t('admin.file_attribute_change'),
            {size: "lg", className: "soubor-atribut-form-modal"}
        ));
    };

    handleZmenitPoradi = () => {
        const {souborAtributyList, dispatch, t} = this.props;
        if (souborAtributyList.rows.length !== 0) {
            this.props.dispatch(modal.ModalActions.show(
                ZmenitPoradiModal,
                {
                    onOrderChanged: (changedIdsMap) => {
                        CiselnikApi.updatePoradiSouborAtributu(changedIdsMap).then(() => {
                            dispatch(modal.ModalActions.hide());
                            dispatch(ciselnikActions.invalidateSouborAtributy());
                        });
                    },
                    items: souborAtributyList.rows,
                    renderItem: i => {
                        return <CardBody key={i.item.id}>
                            <Row>
                                <Col xs={12}>{i.item.nazevAtribut}</Col>
                            </Row>
                        </CardBody>;
                    },
                },
                t('change_in_order'),
                {size: "lg", className: "card-form-modal"}
            ));
        } else {
            toastr.warning("Žádné atributy k řazení");
        }
    };

    handleVcetneNeaktivnich = (e) => {
        const {souborAtributyList} = this.props;
        this.props.dispatch(ciselnikActions.filterSouborAtributy({
            ...souborAtributyList.filter,
            vcetneNeaktivnich: e.target.checked
        }, false));
    };

    renderContextMenu = (souborAtribut) => {
        const {t} = this.props;
        return <FixedDropDownButton color="action action-hover" noCaret title={<Icon icon="ellipsis-v"/>}>
            <DropdownItem key="0" onClick={sinkEvent(this.handleEditSouborAtribut.bind(this, souborAtribut))}>{t('edit')}</DropdownItem>
        </FixedDropDownButton>
    }

    render() {
        const {souborAtributyList, t} = this.props;
        let content;
        if (souborAtributyList.fetched) {
            if (souborAtributyList.rows.length !== 0) {
                content = souborAtributyList.rows.map(souborAtribut => {
                    return <CardBody key={souborAtribut.id} className={souborAtribut.neaktivni ? "neaktivni" : ""}>
                        <ActionsRow actions={this.renderContextMenu(souborAtribut)} onClick={this.handleEditSouborAtribut.bind(this, souborAtribut)}>
                            <Row>
                                <Col xs={3}>{souborAtribut.nazevAtribut}</Col>
                                <Col xs={1}>{souborAtribut.povinne ? t('yes') : t('no')}</Col>
                                <Col xs={1}>{souborAtribut.neaktivni ? t('no') : t('yes')}</Col>
                                <Col xs={3}>{souborAtribut.hodnoty.map(p => p.hodnotaAtribut).join(", ")}</Col>
                            </Row>
                        </ActionsRow>
                    </CardBody>;
                });
            } else {
                content = <CardBody><i>{t('admin.no_file_attribute')}</i></CardBody>
            }
        } else {
            content = <Loader/>
        }
        const vcetneNeaktivnich = souborAtributyList.filter.vcetneNeaktivnich || false;
        return <AdminPage
            title={t('admin.file_attributes')}
            subtitle={t('admin.system_operator_file_attributes')}
            content={
                <div>
                    <ButtonToolbar>
                        <Button color="primary" onClick={this.handleCreateSouborAtribut}>{t('new_m')}</Button>
                        <Button color="secondary" onClick={this.handleZmenitPoradi}>{t('change_order')}</Button>
                        <CustomCheckbox label={t('including_inactive')} value={vcetneNeaktivnich} onChange={this.handleVcetneNeaktivnich}/>
                    </ButtonToolbar>
                    <TablePanel header={
                        <Row>
                            <Col xs={3}>{t('labels.name')}</Col>
                            <Col xs={1}>{t('labels.required')}</Col>
                            <Col xs={1}>{t('active')}</Col>
                            <Col xs={3}>{t('values')}</Col>
                        </Row>
                    }>
                        {content}
                    </TablePanel>
                </div>
            }
        />}
}

function mapStateToProps(state) {
    return {
        souborAtributyList: utils.storeFromArea(state, ciselnikActions.SOUBOR_ATRIBUTY_LIST_AREA),
    }
}

export default connect(mapStateToProps)(withTranslation()(SouborAtributyPage));
